import React, { useRef } from 'react'
import { useParams } from 'react-router-dom'
import { useAuth } from '@hooks'
import { IconText } from '@components/UI'

import { ACTION_TYPES } from '../../../contexts/FinderContext'
import { useFinderDispatch } from '../../../hooks'
import { useClassroomQuery, useFileUpload } from '@components/Classroom/hooks'

const Upload = () => {
  const { id: appointmentId } = useParams()
  const input = useRef(null)
  const dispatch = useFinderDispatch()
  const { profile } = useAuth()
  const {
    data: { participants = {} }
  } = useClassroomQuery()

  const upload = useFileUpload({
    participants: [profile.id, ...Object.keys(participants || {})],
    onOversize: (payload) =>
      dispatch({ type: ACTION_TYPES.UPDATE_OVERSIZE, payload }),
    defaultBody: appointmentId
      ? {
          appointment: appointmentId
        }
      : {}
  })

  return (
    <div className='control-container dark with-text'>
      <button onClick={() => input.current.click()}>
        <IconText icon='upload fill' value='Upload Files' group='a' />
      </button>

      <input
        ref={input}
        type='file'
        style={{ display: 'none' }}
        multiple
        onChange={(event) =>
          upload(Array.from(event.target.files)).finally(() => {
            input.current.value = ''
          })
        }
      />
    </div>
  )
}

export default Upload
